'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchItemDetailsIfNeeded = exports.isItemDetailLoading = exports.getLoadTimeForItemDetail = exports.getItemDetail = exports.LOAD_ITEM_DETAILS_SUCCESS = exports.LOAD_ITEM_DETAILS_REQUEST = exports.LOAD_ITEM_DETAILS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _config = require('../modules/config');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_ITEM_DETAILS_FAIL = exports.LOAD_ITEM_DETAILS_FAIL = 'la/domain/itemDetail/LOAD_FAIL';
var LOAD_ITEM_DETAILS_REQUEST = exports.LOAD_ITEM_DETAILS_REQUEST = 'la/domain/itemDetail/LOAD_REQUEST';
var LOAD_ITEM_DETAILS_SUCCESS = exports.LOAD_ITEM_DETAILS_SUCCESS = 'la/domain/itemDetail/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_ITEM_DETAILS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.itemIds)
            });
        case LOAD_ITEM_DETAILS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_ITEM_DETAILS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.itemDetails) {
                action.payload.itemDetails.forEach(function (x) {
                    existing[x.itemId] = (0, _extends3.default)({}, x);
                    loaded[x.itemId] = time;
                    loading = (0, _difference2.default)(loading, [x.itemId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.itemDetail;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and passes both params to every function on
// the way down.
var getItemDetail = exports.getItemDetail = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForItemDetail = exports.getLoadTimeForItemDetail = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isItemDetailLoading = exports.isItemDetailLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchItemDetail = function shouldFetchItemDetail(state, itemId) {
    if (!itemId) return false;
    var item = getItemDetail(state, itemId);
    if (item) {
        var loaded = getLoadTimeForItemDetail(state, itemId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isItemDetailLoading(state, itemId);
    return !loading;
};

var whichItemDetailsNeeded = function whichItemDetailsNeeded(state, itemIds) {
    return itemIds.filter(function (itemId) {
        return shouldFetchItemDetail(state, itemId);
    });
};

/* ACTION CREATORS */
var loadItemDetailsFail = function loadItemDetailsFail(itemIds, error) {
    return {
        error: true,
        meta: { itemIds: itemIds },
        payload: error,
        type: LOAD_ITEM_DETAILS_FAIL
    };
};

var loadItemDetailsRequest = function loadItemDetailsRequest(itemIds) {
    return {
        payload: itemIds,
        type: LOAD_ITEM_DETAILS_REQUEST
    };
};

var loadItemDetailsSuccess = function loadItemDetailsSuccess(itemIds, results) {
    return {
        meta: { actionTime: Date.now(), itemIds: itemIds },
        payload: results,
        type: LOAD_ITEM_DETAILS_SUCCESS
    };
};

var loadItemDetails = function loadItemDetails(itemIds) {
    return function (dispatch, getState) {
        var state = getState();
        var deployment = (0, _config.getDeployment)(state);
        dispatch(loadItemDetailsRequest(itemIds));
        return _api.ItemDetail.fetchItemDetailsByIds({ deployment: deployment, itemIds: itemIds }).then(function (response) {
            dispatch(loadItemDetailsSuccess(itemIds, response.data));
        }).catch(function (error) {
            dispatch(loadItemDetailsFail(itemIds, error));
        });
    };
};

var fetchItemDetailsIfNeeded = exports.fetchItemDetailsIfNeeded = function fetchItemDetailsIfNeeded(itemIds) {
    return function (dispatch, getState) {
        var needed = whichItemDetailsNeeded(getState(), itemIds);
        if (needed.length) {
            return dispatch(loadItemDetails(needed));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/itemDetail.js
// module id = DAZk
// module chunks = 46